import { UUID } from '@Protium/vue-ozone-utils/types/utils'
import { ServiceType } from './service'

export enum DirectrSyncTypes {
  Order = 'order',
  SourceOrder = 'source_order',
  Product = 'product',
  StockItem = 'stock_item',
  Inventory = 'inventory',
  Invoice = 'invoice',
}

// TODO: implement as selection
export enum DirectSyncLevel {
  Disabled,
  Pull,
  Push,
  Sync
}

export interface PingbackConfig {
  service?: string
  query?: PingbackQuery
  map?: Record<string, any>
  /* @deprecated **/
  url?: string
}

export interface CatalogueFulfillmentTiers {
  default?: UUID
  xs?: UUID
  s?: UUID
  m?: UUID
  l?: UUID
  xl?: UUID
  xxl?: UUID
}

export enum SyncActionType {
  // orders / supply orders
  Accepted = 'accepted',
  Created = 'created',
  Fulfilled = 'fulfilled',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  OnHold = 'hold',
  Issue = 'issue',
  Issue_resolved = 'issue_resolved',
  Picked = 'picked',
  Transit = 'shipment_progress',

  // generic
  // default push behaviour, also without specified action should alway be "create"
  Default = 'default',
  Create = 'default',
  Delete = 'delete',

  // product
  Deactivate = 'deactivate',
  Archive = 'archive',

  // inventory
  Add = 'add',
  Subtract = 'subtract',
  Set = 'set',
  Clear = 'cleared',

  // invoice
  Sent = 'Sent',
  Credited = 'credited'
}

// NOTE subsets of SyncActionType per content-type for rendering puropses
export const Hooks = {
  [DirectrSyncTypes.Order]: [SyncActionType.Created, SyncActionType.Accepted, SyncActionType.Rejected, SyncActionType.Fulfilled, SyncActionType.Cancelled, SyncActionType.Issue_resolved, SyncActionType.Issue, SyncActionType.Transit, SyncActionType.Picked],
  [DirectrSyncTypes.SourceOrder]: [SyncActionType.Created, SyncActionType.Accepted, SyncActionType.Rejected, SyncActionType.Fulfilled, SyncActionType.Cancelled, SyncActionType.Issue_resolved, SyncActionType.Issue],
  [DirectrSyncTypes.Product]: [SyncActionType.Archive],
  [DirectrSyncTypes.Inventory]: [SyncActionType.Set, SyncActionType.Clear],
  [DirectrSyncTypes.Invoice]: [SyncActionType.Sent, SyncActionType.Credited],
}

export type PingbackQuery = Record<string, any>

export interface PingbackConfig {
  service?: string
  query?: PingbackQuery
  url?: string,
  map?: Record<string, any>
}

export interface SyncTypeBaseConfig<H extends string = ''> {
  service?: ServiceType,
  active?: boolean,
  trigger?: string,

  hooks?: ServicePushHooks<H>
}

export type ServicePushHooks<Keys extends string, H extends PingbackConfig = PingbackConfig> = { [K in Keys]?: H }

export interface CatalogueSyncConfig {
  service?: ServiceType,
  [DirectrSyncTypes.Order]?: SyncTypeBaseConfig<SyncActionType.Accepted | SyncActionType.Created | SyncActionType.Fulfilled | SyncActionType.Rejected | SyncActionType.Cancelled | SyncActionType.Issue_resolved>,
  [DirectrSyncTypes.Product]?: SyncTypeBaseConfig & {
    use_parent_sku?: boolean
    pricing_manager_service?: string
  },
  [DirectrSyncTypes.Inventory]?: SyncTypeBaseConfig & {
    offset?: number | string,
    limit?: number | string
  }
}

export interface CatalogueServiceConfig {
  /** @deprecated will be migrated to "id" */
  service?: string // TODO migate "service" to "id"
  id?: ServiceType
  name?: string
  sync?: CatalogueSyncConfig
}
